import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from '../_template/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_template/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import { Routes } from './routing/Routes'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

type Props = {
    basename: string
}

const RECAPTCHAKEY = process.env.REACT_APP_RECAPTCHAKEY || '6LfDuBspAAAAAMW8oOIMVERe9c1ipCJw_1jT0qWO'

const App: React.FC<Props> = ({ basename }) => {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <BrowserRouter basename={basename}>
                <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHAKEY} scriptProps={{ nonce: "googlerecaptcha" }}>
                    <I18nProvider>
                        <LayoutProvider>
                            <AuthInit>
                                <Routes />
                            </AuthInit>
                        </LayoutProvider>
                    </I18nProvider>
                </GoogleReCaptchaProvider>
            </BrowserRouter>
        </Suspense>
    )
}

export { App }
